export default function Card({ children, className = "" }) {
  return (
    <div className={"rounded-2xl border bg-[rgb(var(--card))] border-[rgb(var(--border))] shadow-[0_1px_6px_rgba(0,0,0,0.07)] " + className}>
      {children}
    </div>
  );
}